import React from 'react';
export function useSelectActionsParticipantShiftsTable(allIds) {
    const [selected, setSelected] = React.useState([]);
    const handleSingleSelect = React.useCallback((row) => {
        setSelected((current) => {
            return current.includes(row.id)
                ? current.filter((id) => id !== row.id) // unselect
                : [...current, row.id]; // select
        });
    }, [setSelected]);
    const handleSelectAll = React.useCallback(() => {
        var _a;
        const allRecordsIds = (_a = allIds === null || allIds === void 0 ? void 0 : allIds.ids) !== null && _a !== void 0 ? _a : [];
        setSelected((prevState) => (prevState.length === allRecordsIds.length ? [] : allRecordsIds));
    }, [allIds]);
    const handleSelectReset = React.useCallback((rowIds) => {
        if (!rowIds) {
            setSelected([]);
        }
        else {
            setSelected((prevState) => prevState.filter((selectedItem) => !rowIds.includes(selectedItem)));
        }
    }, [setSelected]);
    return {
        handleSingleSelect,
        handleSelectAll,
        handleSelectReset,
        selected,
    };
}
